let app = null;
let auth = null;
let db = null;

const firebaseConfig = {
  apiKey: process.env.GATSBY_FIREBASE_API_KEY,
  authDomain: process.env.GATSBY_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.GATSBY_FIREBASE_PROJECT_ID,
  storageBucket: process.env.GATSBY_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.GATSBY_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.GATSBY_FIREBASE_APP_ID,
};

export const initFirebase = async () => {
  if (typeof window === "undefined") {
    console.warn("Firebase cannot be initialized during static build");
    return { app: null, auth: null, db: null };
  }
  
  if (!app) {
    const { initializeApp } = await import("firebase/app");
    const { getAuth } = await import("firebase/auth");
    const { getFirestore } = await import("firebase/firestore");
    
    app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);
  }
  return { app, auth, db };
};

export const getFirebase = () => {
  if (typeof window === "undefined") {
    console.warn("Firebase is not available during static build");
    return { app: null, auth: null, db: null };
  }
  if (!app) {
    console.warn('Firebase has not been initialized. Call initFirebase() first.');
  }
  return { app, auth, db };
};

export { app, auth, db };